import { render, staticRenderFns } from "./reasonAction.vue?vue&type=template&id=3dd4379e&scoped=true"
import script from "./reasonAction.vue?vue&type=script&lang=js"
export * from "./reasonAction.vue?vue&type=script&lang=js"
import style0 from "./reasonAction.vue?vue&type=style&index=0&id=3dd4379e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd4379e",
  null
  
)

export default component.exports